import { createAuthClient } from "better-auth/react";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    credentials: "include",
  },
});
